module.exports = __webpack_public_path__ + "static/media/chart2.f351fe15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/chart2.svg
// module id = 838
// module chunks = 21